import type { TripAPI } from './definitions/APITypes';

import type {
  PageableContent,
  PageableContentAPI,
  Trip,
} from '@cobliteam/common-types';

export const toTrip = (tripAPI: TripAPI): Trip => ({
  startTimestamp: tripAPI.start_timestamp,
  endTimestamp: tripAPI.end_timestamp,
  isFootageAvailable: tripAPI.is_footage_available,
});

export const toTripPage = (
  page: PageableContentAPI<TripAPI>
): PageableContent<Trip> => ({
  content: page.content.map(toTrip),
  last: page.last,
  totalPages: page.total_pages,
  totalElements: page.total_elements,
  numberOfElements: page.number_of_elements,
  number: page.number,
  size: page.size,
  first: page.first,
  empty: page.empty,
});
